import ApiService from '@shared/services/api.service';

const ListingOfTheResource = '/domain_subscriptions';

const DomainService = {
  fetchResources: async () => ApiService.get(ListingOfTheResource),
  fetchResourcesActive: async () => ApiService.get(`${ListingOfTheResource}/active`),
  fetchResourcesInactive: async () => ApiService.get(`${ListingOfTheResource}/inactive`),
  addSubscribedDomain: async (body) => ApiService.post('/domains', body),
  fetchListOfDomainSubscribed: async () => ApiService.get('/domains'),
  fetchSubscribedDomainWebpagesById: async (domainId) => ApiService.get(`/domains/${domainId}/urls`),
  fetchDomainStatisticsById: async (domainId) => ApiService.get(`/domains/${domainId}/stats`),
  fetchDomainCrawlsById: async (domainId) => ApiService.get(`/domains/${domainId}/crawls`),
  fetchDomainIgnoredUrls: async (domainId) => ApiService.get(`/domains/${domainId}/ignored-urls`),
  deleteDomain: async (domainId) => ApiService.delete(`/domains/${domainId}`),
  fetchDomainCrawlSchedules: async () => ApiService.get(`/domain_crawl_schedules`),
  addDomainCrawlSchedule: async (body) => ApiService.post(`/domain_crawl_schedules`, body),
  getDomainCrawlSchedule: async (crawlScheduleId) => ApiService.get(`/domain_crawl_schedules/${crawlScheduleId}`),
  updateDomainCrawlSchedule: async (crawlScheduleId, body) => ApiService.put(`/domain_crawl_schedules/${crawlScheduleId}`, body),
  deleteDomainCrawlSchedule: async (crawlScheduleId) => ApiService.delete(`/domain_crawl_schedules/${crawlScheduleId}`),
  addIgnoredUrls: async (domainId, body) => ApiService.post(`/domains/${domainId}/ignore-urls`, body),
  removeIgnoredUrls: async (domainId, body) => ApiService.post(`/domains/${domainId}/remove-ignored-urls`, body),
};
export default DomainService;
